import { render } from "./SendEmailPropsCmp.vue?vue&type=template&id=355eb126"
import script from "./SendEmailPropsCmp.vue?vue&type=script&lang=js"
export * from "./SendEmailPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__